import React from 'react';

function App() {
  return(
    <>
      <header className="intelligence-augmentation-header">
        <div className="ia-container">
          <div className="ia-content">
            <div className="ia-logo-section">
              <img src="/nxt-humans-logo.png" alt="NXT HUMANS Logo" className="ia-logo-image" />
            </div>
            <div className="ia-text-section">
              <div className="ia-introducing">Introducing</div>
              <div className="ia-main-text">
                <div className="ia-intelligence">Intelligence</div>
                <div className="ia-augmentation">Augmentation</div>
              </div>
            </div>
          </div>
        </div>
      </header>
      <div className="enterprise-hero">
        <div className="enterprise-container">
          <div className="hero-content">
            <h2 className="hero-title">Customer Experience Intelligence Suite</h2>
            <p className="hero-subtitle">Advanced customer journey analysis, data collection, and AI-driven insights</p>
          </div>
        </div>
      </div>
      <div className="enterprise-container">
        <div className="apps-section">
          <div className="section-header">
            <div className="section-icon">
              <i className="fas fa-database"></i>
            </div>
            <div className="section-info">
              <h2 className="section-title">Data Collection &amp; Ingestion</h2>
              <p className="section-description">Gather comprehensive data from multiple sources for analysis</p>
            </div>
          </div>
          <div className="enterprise-grid">
            <div className="enterprise-card" data-category="collection" data-service="reddit-ripper">
              <div className="card-header">
                <div className="service-icon">
                  <i className="fab fa-reddit-alien"></i>
                </div>
                <div className="service-status">
                  <div className="status-indicator status-unknown" id="reddit-ripper-status"></div>
                </div>
              </div>
              <div className="card-content">
                <h3 className="service-title">Reddit Data Collector</h3>
                <p className="service-description">Extract and analyze posts, comments, and engagement metrics from Reddit communities for comprehensive social sentiment analysis</p>
                <div className="service-tags">
                  <span className="tag">Social Media</span>
                  <span className="tag">Data Mining</span>
                </div>
              </div>
              <div className="card-footer">
                <a href="https://localhost:8446/" id="reddit-ripper-url" target="_blank" rel="noreferrer" className="enterprise-btn">
                  <i className="fas fa-external-link-alt"></i>
                  Launch Application
                </a>
              </div>
            </div>
            
            <div className="enterprise-card" data-category="collection" data-service="video-analyzer">
              <div className="card-header">
                <div className="service-icon">
                  <i className="fas fa-video"></i>
                </div>
                <div className="service-status">
                  <div className="status-indicator status-unknown" id="video-analyzer-status"></div>
                </div>
              </div>
              <div className="card-content">
                <h3 className="service-title">Video Transcription Service</h3>
                <p className="service-description">Advanced AI-powered video transcription with OpenAI Whisper integration for accurate speech-to-text conversion and content analysis</p>
                <div className="service-tags">
                  <span className="tag">AI/ML</span>
                  <span className="tag">Transcription</span>
                </div>
              </div>
              <div className="card-footer">
                <a href="https://localhost:8448/" id="video-analyzer-url" target="_blank" rel="noreferrer"  className="enterprise-btn">
                  <i className="fas fa-external-link-alt"></i>
                  Launch Application
                </a>
              </div>
            </div>
          </div>
        </div>
        <div className="apps-section">
          <div className="section-header">
            <div className="section-icon">
              <i className="fas fa-chart-line"></i>
            </div>
            <div className="section-info">
              <h2 className="section-title">Analysis &amp; Journey Mapping</h2>
              <p className="section-description">Advanced analytics and customer journey visualization powered by enterprise AI</p>
            </div>
          </div>
          <div className="enterprise-grid">
            <div className="enterprise-card" data-category="analysis" data-service="social-research">
              <div className="card-header">
                <div className="service-icon">
                  <i className="fas fa-chart-pie"></i>
                </div>
                <div className="service-status">
                  <div className="status-indicator status-unknown" id="social-research-status"></div>
                </div>
              </div>
              <div className="card-content">
                <h3 className="service-title">Social Research Analytics</h3>
                <p className="service-description">Enterprise social analytics platform with advanced topic modeling, sentiment analysis, and vector-based similarity search capabilities</p>
                <div className="service-tags">
                  <span className="tag">Analytics</span>
                  <span className="tag">ML/AI</span>
                  <span className="tag">PostgreSQL</span>
                </div>
              </div>
              <div className="card-footer">
                <a href="https://localhost:8447/" id="social-research-url" target="_blank" rel="noreferrer"  className="enterprise-btn">
                  <i className="fas fa-external-link-alt"></i>
                  Launch Application
                </a>
              </div>
            </div>
            
            <div className="enterprise-card" data-category="analysis" data-service="journey-mapper">
              <div className="card-header">
                <div className="service-icon">
                  <i className="fas fa-route"></i>
                </div>
                <div className="service-status">
                  <div className="status-indicator status-unknown" id="journey-mapper-status"></div>
                </div>
              </div>
              <div className="card-content">
                <h3 className="service-title">Journey Mapper (Claude 3.7)</h3>
                <p className="service-description">Interactive customer journey mapping powered by Claude 3.7 Sonnet with intelligent content analysis and visual journey creation</p>
                <div className="service-tags">
                  <span className="tag">Claude AI</span>
                  <span className="tag">Journey Mapping</span>
                </div>
              </div>
              <div className="card-footer">
                <a href="https://localhost:8444/" id="journey-mapper-url" target="_blank" rel="noreferrer"  className="enterprise-btn">
                  <i className="fas fa-external-link-alt"></i>
                  Launch Application
                </a>
              </div>
            </div>

            <div className="enterprise-card" data-category="analysis" data-service="openai-journey-mapper">
              <div className="card-header">
                <div className="service-icon">
                  <i className="fas fa-brain"></i>
                </div>
                <div className="service-status">
                  <div className="status-indicator status-unknown" id="openai-journey-mapper-status"></div>
                </div>
              </div>
              <div className="card-content">
                <h3 className="service-title">Journey Mapper (OpenAI o3)</h3>
                <p className="service-description">Advanced reasoning-powered journey mapping using OpenAI's o3 model with sophisticated cognitive analysis and extended thinking capabilities</p>
                <div className="service-tags">
                  <span className="tag">OpenAI o3</span>
                  <span className="tag">Advanced Reasoning</span>
                </div>
              </div>
              <div className="card-footer">
                <a href="https://localhost:8445/" id="openai-journey-mapper-url" target="_blank" rel="noreferrer"  className="enterprise-btn">
                  <i className="fas fa-external-link-alt"></i>
                  Launch Application
                </a>
              </div>
            </div>
          </div>
        </div>
        <div className="apps-section">
          <div className="section-header">
            <div className="section-icon">
              <i className="fas fa-magic"></i>
            </div>
            <div className="section-info">
              <h2 className="section-title">Content Generation &amp; Visualization</h2>
              <p className="section-description">AI-powered content creation and interactive visualization tools</p>
            </div>
          </div>
          <div className="enterprise-grid">
            <div className="enterprise-card" data-category="generation" data-service="linkedin-generator">
              <div className="card-header">
                <div className="service-icon">
                  <i className="fab fa-linkedin"></i>
                </div>
                <div className="service-status">
                  <div className="status-indicator status-unknown" id="linkedin-generator-status"></div>
                </div>
              </div>
              <div className="card-content">
                <h3 className="service-title">LinkedIn Content Generator</h3>
                <p className="service-description">Transform customer journey insights into professional LinkedIn content with AI-powered optimization for engagement and reach</p>
                <div className="service-tags">
                  <span className="tag">Content Creation</span>
                  <span className="tag">Social Media</span>
                </div>
              </div>
              <div className="card-footer">
                <a href="https://localhost:8449/" id="linkedin-generator-url" target="_blank" rel="noreferrer"  className="enterprise-btn">
                  <i className="fas fa-external-link-alt"></i>
                  Launch Application
                </a>
              </div>
            </div>
            
            <div className="enterprise-card" data-category="generation" data-service="miro-generator">
              <div className="card-header">
                <div className="service-icon">
                  <i className="fas fa-project-diagram"></i>
                </div>
                <div className="service-status">
                  <div className="status-indicator status-unknown" id="miro-generator-status"></div>
                </div>
              </div>
              <div className="card-content">
                <h3 className="service-title">Miro Board Generator</h3>
                <p className="service-description">Claude-powered conversion of journey maps into professional, interactive Miro boards with UX expertise and zero data loss</p>
                <div className="service-tags">
                  <span className="tag">Claude AI</span>
                  <span className="tag">Miro Integration</span>
                  <span className="tag">UX Design</span>
                </div>
              </div>
              <div className="card-footer">
                <a href="https://localhost:8450/" id="miro-generator-url" target="_blank" rel="noreferrer"  className="enterprise-btn">
                  <i className="fas fa-external-link-alt"></i>
                  Launch Application
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>
      <footer className="nxt-footer">
        <div className="container">
          <div className="nxt-footer-content">
            <div className="nxt-footer-text">
              <p>© 2025 NXT Humans. All rights reserved.</p>
            </div>
          </div>
        </div>
      </footer>

      <button className="chat-launch-button" aria-label="Open chat"><i className="fa-solid fa-message"></i></button>
      <div className="chatbot-widget hidden">
        <div className="chat-header">
          <div className="chat-header-left">
            <div className="chat-header-icon">
              <i className="fa-solid fa-robot"></i>
            </div>
            <div className="chat-header-title">NXT Humans Assistant</div>
          </div>
          <div className="chat-header-actions">
            <button className="chat-header-button minimize-button" aria-label="Minimize chat">
              <i className="fa-solid fa-minus"></i>
            </button>
            <button className="chat-header-button close-button" aria-label="Close chat">
              <i className="fa-solid fa-xmark"></i>
            </button>
          </div>
        </div>
        <div className="chat-body">
          <div className="message assistant">
              Hello! I'm your NXT Humans CX Workbench Assistant. I can help you with:<br/><br/>• Reddit data collection and analysis<br/>• Social research with topic modeling and sentiment analysis<br/>• Customer journey mapping (Claude 3.7 or OpenAI o3)<br/>• Video transcription and analysis<br/><br/>How can I assist you today?
          </div>
        </div>
        <div className="chat-footer">
          <div className="chat-actions">
            <label className="chat-action-button file-upload-label" aria-label="Upload file"/>
              <i className="fa-solid fa-paperclip"></i>
              <input type="file" className="file-input" accept=".pdf,.csv,.txt,.json"/>
          </div>
          <div className="chat-input">
            <textarea className="chat-input-textarea" placeholder="Type a message..." rows="1" aria-label="Chat message input"></textarea>
          </div>
          <button className="chat-send-button" disabled="" aria-label="Send message">
            <i className="fa-solid fa-paper-plane"></i>
          </button>
        </div>
     </div>
    </>
  );
}

export default App;
